import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/stores";
import RouteApp from "./route";
import { ToastContainer } from "react-toastify";
import "./styles/globals.scss";

export default function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RouteApp />
        <ToastContainer limit={1} autoClose={3000} />
      </PersistGate>
    </Provider>
  );
}
